import { Divider, IconButton, Stack, Typography } from "@mui/material"
import { RightDrawer } from "lib/@components/drawer/right-drawer"
import { Repeat } from "lib/@components/repeat"
import Iconify from "minimals-template/components/Iconify"
import { CostFacilityCostRow } from "./cost-facility-cost-row"

export function AllFacilitiesDrawer({ open, onClose, facilities, currencySymbol, onFacilityClick }) {
    const count = facilities?.length || 0

    return (
        <RightDrawer open={open} setOpen={handleSetOpen} onClose={onClose}>
            <Stack data-cy="all-facilities-drawer" spacing={2} sx={{ height: "100%" }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Stack>
                        <Typography variant="h6">All Facilities</Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ fontSize: 14 }}>
                            {count} total
                        </Typography>
                    </Stack>
                    <IconButton aria-label="Close" size="small" onClick={onClose}>
                        <Iconify icon="eva:close-fill" />
                    </IconButton>
                </Stack>

                <Divider sx={{ borderStyle: "dashed" }} />

                <Stack spacing={0} divider={<Divider sx={{ borderStyle: "dashed" }} />} sx={{ overflowY: "auto" }}>
                    <Repeat
                        list={facilities || []}
                        item={
                            <CostFacilityCostRow
                                currencySymbol={currencySymbol}
                                onFacilityClick={handleFacilityClick}
                            />
                        }
                    />
                </Stack>
            </Stack>
        </RightDrawer>
    )

    function handleSetOpen(value) {
        if (!value) onClose?.()
    }

    function handleFacilityClick(facility) {
        onClose?.()
        onFacilityClick?.(facility)
    }
}
